import { autoserialize, autoserializeAs } from 'cerialize';
import { Rider } from './rider';
import { Address } from './address';
import { OrganizationRiderDetail } from './organization-rider-detail';
import { Driver } from './driver';

export class RiderProfileDetail {
  @autoserializeAs(Rider)
  rider: Rider;

  @autoserializeAs(Address)
  address: Address;

  @autoserializeAs(OrganizationRiderDetail)
  organizationRiderDetails: Array<OrganizationRiderDetail>;

  @autoserialize
  firstName: string;

  @autoserialize
  lastName: string;

  @autoserialize
  favoriteDrivers: Array<Driver>;

  @autoserialize
  ignoredDrivers: Array<Driver>;
}
